import ApiService from '@zola-helpers/client/dist/es/http/api';
import type {
  WCardDesignFamilySearchRequest,
  WCardSuiteSearchRequest,
  WCardSuiteSearchView,
} from '@zola/svc-web-api-ts-client';

export const getFacetedSuites = (
  suitesRequestParams: WCardDesignFamilySearchRequest
): Promise<WCardDesignFamilySearchRequest> => {
  return ApiService.post(
    '/web-api/v1/card-catalog/card-design-family/search/faceted',
    suitesRequestParams
  );
};

export const getFacetedCards = (
  cardsRequestParams: WCardSuiteSearchRequest
): Promise<WCardSuiteSearchView> => {
  return ApiService.post('/web-api/v1/card-catalog/search/faceted', cardsRequestParams);
};

export const getFacetedFavoriteCards = (
  cardsRequestParams: WCardSuiteSearchRequest
): Promise<WCardSuiteSearchView> => {
  return ApiService.post('/web-api/v1/card-catalog/favorites/search/faceted', cardsRequestParams);
};
